import React from "react";
import PropTypes from "prop-types";

import {navItemInterface} from "../../../../interfaces/featureInterface";
import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import {shopContextAction, useShopContext} from "./shopNavItemsContext";
import ShopFeatureOptionsCommon from "../shopFeatureOptionsCommon";


const ShopCategoryListFeatureOptions = (props) => {

  const {navItem} = props;
  const feature = navItem.part;

  const {shopContextState, shopContextDispatch} = useShopContext();

  const {shopNavItems} = shopContextState;

  const optionsButtonClick = (option) => {

    const featureLabel = Analytics.getSkuForAnalytics(option.feature);
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.shopFeaturesListOptions + featureLabel);

    const newNavItems = shopNavItems.map(navItem => {
      if (navItem.part.dbFeature.id === feature.dbFeature.id) {
        return {part: option.feature}
      }
      return navItem
    })
    shopContextDispatch(shopContextAction({shopNavItems: newNavItems}))
  };

  return (
    <ShopFeatureOptionsCommon feature={feature}
                              navItemOptions={navItem.colorOptions}
                              optionsButtonClick={optionsButtonClick}/>
  )
};

ShopCategoryListFeatureOptions.propTypes = {
  navItem: PropTypes.shape(navItemInterface).isRequired,
}

export default ShopCategoryListFeatureOptions
